import LogoutIcon from '@mui/icons-material/Logout';
import LoginIcon from '@mui/icons-material/Login';
import {
  Avatar,
  Box,
  TextField,
  Divider,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Popover,
  Typography
} from '@mui/material';
import PropTypes from 'prop-types';
import toast from 'react-hot-toast';
import { useAuth } from '../../hooks/use-auth';
import { stringAvatar } from '../../utils/avatar';
import Autocomplete from '@mui/material/Autocomplete';

export const Account = (props) => {
  const { anchorEl, onClose, open, ...other } = props;
  const { logout, login, impersonate, user, realUser, isImpersonated } = useAuth();
  // console.log('user', { user, roles: user.roles });

  const handleLogout = async () => {
    try {
      onClose?.();
      await logout();
    } catch (error) {
      console.error(error);
      toast.error('Impossible de se déconnecter');
    }
  };

  const handleLogin = async () => {
    try {
      onClose?.();
      await login();
    } catch (error) {
      console.error(error);
      toast.error('Impossible de se reconnecter');
    }
  };


  let impersonationOptions = realUser?.canImpersonate
    // unwanted
    ?.filter((user) => user.equipe !== 'KONECTA' && user.equipe !== 'DEPART')
    // duplicates
    ?.filter((user, index, self) =>
      index === self.findIndex((t) => (
        t.uid === user.uid
      ))
    )
    // simplify
    ?.map(user => ({ label: user.fullName + ' ' + user.uid, value: user.uid, equipe: user.equipe, key: user.uid }))
    // sort
    .sort((a, b) => a?.equipe?.toUpperCase()?.localeCompare(b?.equipe?.toUpperCase()))

  return (
    <Popover
      anchorEl={anchorEl}
      anchorOrigin={{
        horizontal: 'center',
        vertical: 'bottom'
      }}
      keepMounted
      onClose={onClose}
      open={open}
      PaperProps={{ sx: { width: 300, maxHeight: '90vh', overflow: 'auto' } }}
      transitionDuration={0}
      {...other}>
      <Box
        sx={{
          alignItems: 'center',
          p: 2,
          display: 'flex'
        }}
      >
        <Avatar
          {...stringAvatar(user.fullName)}
          sx={{
            ...(isImpersonated && {
              border: '2px solid red'
            })
          }}
        />
        <Box
          sx={{
            ml: 1
          }}
        >
          <Typography variant="body1">
            {user.fullName}<br />
            {user.nni}
          </Typography>
        </Box>
      </Box>
      <Divider />
      {realUser?.canImpersonate && realUser?.canImpersonate?.length !== 0 && (
        <>
          {/* impersonation */}
          <Autocomplete
            disablePortal
            options={impersonationOptions}
            groupBy={(option) => option.equipe?.toUpperCase()}
            renderInput={(params) => <TextField {...params} label="Prendre la vue de" />}
            // by default it took value as key
            onChange={(event, newValue) => {
              // console.log('autocomplete', { newValue });
              if (newValue) {
                impersonate(newValue.value);
              } else {
                handleLogin();
              }
            }}
            sx={{ m: 1.5 }}
          />

          <Divider />
        </>
      )}
      {/* Parametres */}
      <Box
        sx={{
          ml: 1
        }}
      >
        <Typography
          color="textPrimary"
          variant="h6"
          sx={{ ml: '25px' }}
        >
          Nom dans les applications
        </Typography>

        <Typography
          color="textSecondary"
          variant="overline"
          sx={{ ml: '25px' }}
        >
          PRAC : {user.pracName}<br />
        </Typography>
        <Typography
          color="textSecondary"
          variant="overline"
          sx={{ ml: '25px' }}
        >
          OSR : {user.osrName}<br />
        </Typography>
        <Typography
          color="textSecondary"
          variant="overline"
          sx={{ ml: '25px' }}
        >
          CUAU : {user.cuauName}<br />
        </Typography>
        <Typography
          color="textSecondary"
          variant="overline"
          sx={{ ml: '25px' }}
        >
          EPLAN : {user.eplanName}<br />
        </Typography>
      </Box>
      <Divider />


      {/* roles */}
      <Box
        sx={{
          ml: 1
        }}
      >
        <Typography
          color="textPrimary"
          variant="h6"
          sx={{ ml: '25px' }}
        >
          Roles
        </Typography>
        {user.roles.map(role => (
          <Typography
            key={role}
            color="textSecondary"
            variant="overline"
            sx={{ ml: '25px' }}
          >
            {role}<br />
          </Typography>
        ))}
      </Box>
      <Divider />
      <Box sx={{ my: 1 }}>
        <MenuItem onClick={handleLogin}>
          <ListItemIcon>
            <LoginIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary={(
              <Typography variant="body1">
                Se reconnecter
              </Typography>
            )}
          />
        </MenuItem>
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <LogoutIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary={(
              <Typography variant="body1">
                Se déconnecter
              </Typography>
            )}
          />
        </MenuItem>
      </Box>
    </Popover>
  );
};

Account.propTypes = {
  anchorEl: PropTypes.any,
  onClose: PropTypes.func,
  open: PropTypes.bool
};
